import { create } from "zustand";
import type {
  FundRequestPayoutMethod,
  FundRequestPayoutInput,
  GenerateFundRequestLinkResult,
} from "../interfaces/payout";

/**
 * The composed money request, captured on the request TransferPage confirm.
 * Ported from raas-widgets-flow-request. In the gallery it is seeded with mock
 * data so the Minting / Request Ready screens render without any API.
 */
export interface IRequestDraft {
  sourceCountry: string;
  destinationCountry: string;
  sourceCurrency: string;
  destinationCurrency: string;
  /** Amount the requester wants to receive, in the destination currency. */
  amount: number;
  payoutMethod: FundRequestPayoutMethod;
  payout: FundRequestPayoutInput;
  capabilityKey?: string;
}

interface RequestState {
  draft: IRequestDraft | null;
  setDraft: (draft: IRequestDraft | null) => void;

  /** Result of the last mint, surfaced on the share screen. */
  mintResult: GenerateFundRequestLinkResult | null;
  setMintResult: (result: GenerateFundRequestLinkResult | null) => void;

  reset: () => void;
}

export const useRequestStore = create<RequestState>((set) => ({
  draft: null,
  setDraft: (draft) => set(() => ({ draft })),
  mintResult: null,
  setMintResult: (mintResult) => set(() => ({ mintResult })),
  reset: () => set(() => ({ draft: null, mintResult: null })),
}));
